import { useEffect, useState } from "react";
import NormalTable from "../../../components/common/Tables/NormalTable";
import { getAllVenueBySlug, getReport } from "../../../api";
import { getTicketTypeBySlug } from "../../../api";
import { PulseLoader } from 'react-spinners';
import ExportToExcel from "../../../components/ExportToExcel/ExportToExcel";
import FlatPickr from "react-flatpickr";
import FormattedDate from "../../../components/common/DateFormat/FormattedDate";

import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
} from "reactstrap";
import ExportToPDF from "../../../components/ExportToPdf/ExportToPdf";
import { handleError } from "../../../utils/errorHandler";
import CommonSelect from "../../../components/common/Select/CommonSelect";
const UserAttendeeReport = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [email, setEmail] = useState("");
  const [phno, setPhno] = useState("");
  const [fullAttendeeList, setFullAttendeeList] = useState<any[]>([]);
  const [attendee, setAttendee] = useState<any[]>([]);
  const [ticketTypes, setTicketTypes] = useState<any[]>([]);
  const [exportTicketData, setExportTicketData] = useState<any[]>([]);
  const [exportAttendeeData, setExportAttendeeData] = useState<any[]>([]);
  const [exportAttendeeDataById, setExportAttendeeDataById] = useState({});
  const [fromDate, setFromDate] = useState<Date>();
  const [toDate, setToDate] = useState<Date>();

  const [reports, setReports] = useState<{ title: string; iconClass: string; ticketSold: string | number; }[]>([
    { title: "Ticket Name", iconClass: "fa-solid fa-ticket fa-2x bg-dark", ticketSold: 0 },
  ]);

  const [bookingList, setBookingList] = useState<any[]>([]);
  const [eventList, setEventList] = useState<any[]>([]);
  const [eventVenues, setEventVenues] = useState<any[]>([]);
  const [selectedVenue, setSelectedVenue] = useState<string>("");

  const ticketTypeSummaries: {
    title: string;
    iconClass: string;
    ticketSold: string;
    // price: string;
    // total: string;
  }[] = [];
  interface ReportItem {
    title: string;
    iconClass: string;
    ticketSold: string | number;
    // price: string | number;
    // total: string | number;
  }

  const getEventVenue = async (eventId: string) => {
    try {
      const resp = await getAllVenueBySlug(eventId);
      const venueOptions = resp.map((item: any) => {
        return {
          value: item.venueId,
          label: item.venueName
        }
      })
      const allVenue = {
        value: "0",
        label: "All Venues"
      }
      setEventVenues([allVenue, ...venueOptions])
    } catch (error) {
      handleError(error)
    }
  }



  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);

        const eventData = localStorage.getItem("eventData");
        console.log("eventData", eventData);

        if (!eventData) return;

        const eventSlug = JSON.parse(eventData).eventId;
        const slugId = JSON.parse(eventData).slugId;
        const venueId = localStorage.getItem("venueId");
        const [reportResponse, ticketTypeResponse, venueResponse] = await Promise.all([
          getReport(eventSlug),
          getTicketTypeBySlug(slugId),
          getEventVenue(slugId)
        ]);


        if (reportResponse) {
          const filteredReportResponse = reportResponse.filter((item: any) =>item.paymentStatus === "paid" && item.bookedBy === "0" && item.venueId === venueId);
          setFullAttendeeList(filteredReportResponse);
          console.log("reportResponse", reportResponse);
          const exportAttendeeData = generateExportData(filteredReportResponse);
          setExportAttendeeData(exportAttendeeData);
          setAttendee(filteredReportResponse);
        }

        if (ticketTypeResponse) {
          setTicketTypes(ticketTypeResponse);
        }
        setBookingList(ticketTypeResponse);

        const ticketTypeCounts: { [key: string]: number } = {};
        const tempTicketTypes = new Set<string>();
        let exportTicket: any[] = [];
        
        ticketTypeResponse.forEach((item: any) => {
          const isGroup = item?.isGroupTicket;
          const groupCount = item?.groupTicketCount;
          let totalTicketsSold = 0;
          if (isGroup) {
            totalTicketsSold = Number(item?.totalTicketsSold) / Number(groupCount);
          } else {
            totalTicketsSold = item?.totalTicketsSold || 0;
          }
          const ticketType = item?.ticketType;
          const groupName = item?.groupName;
          const price = item?.price || 0;

          if (ticketType && groupName) {
            const combinedKey = `(${groupName}) ${ticketType}`;

            ticketTypeSummaries.push({
              title: combinedKey,
              iconClass: "fa-solid fa-ticket fa-2x bg-dark",
              ticketSold: `Tickets Sold: ${totalTicketsSold}`,
              // price: `Price: $${Number(price).toFixed(2)}`,
              // total: `Total Ticket Amount: $${Number(price * totalTicketsSold).toFixed(2)}`,
            });

            const obj = {
              title: combinedKey,
              ticketSold: `${totalTicketsSold}`,
              price: `$${Number(price).toFixed(2)}`,
              total: `$${Number(price * totalTicketsSold).toFixed(2)}`,
            }
            exportTicket.push(obj);
          }

        });
        setExportTicketData(exportTicket);
        setReports(ticketTypeSummaries);
      } catch (error) {
        console.error("Error fetching attendee report:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  },
    []);
  const onSelectedVenue = async (e: any) => {
    setIsLoading(true);
    try {
      const selectedVenue = e;
      const eventData = localStorage.getItem("eventData");
      if (!eventData) return;
      const eventSlug = JSON.parse(eventData).eventId;
      const slugId = JSON.parse(eventData).slugId;
      const venueId = localStorage.getItem("venueId");
      const reportResponse = await getReport(eventSlug);
      let filteredReportResponse: any[] = [];
      if (selectedVenue !== "0") {
        filteredReportResponse = reportResponse.filter((item: any) => item.paymentStatus === "paid" && item.venueId === selectedVenue && item.venueId === venueId);
        setFullAttendeeList(filteredReportResponse);
        setAttendee(filteredReportResponse);
        const exportAttendeeData = generateExportData(filteredReportResponse);
        setExportAttendeeData(exportAttendeeData);
      } else {
        filteredReportResponse = reportResponse.filter((item: any) => item.paymentStatus === "paid");
        setFullAttendeeList(filteredReportResponse);
        setAttendee(filteredReportResponse);
        const exportAttendeeData = generateExportData(filteredReportResponse);
        setExportAttendeeData(exportAttendeeData);
      }
      setSelectedVenue(selectedVenue);
    } catch (error) {
      handleError(error);
    } finally {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    const filtered = fullAttendeeList.filter((attendee: any) => {
      const name = attendee?.bookingObject?.primaryContactDetails?.firstName?.toLowerCase() || "";
      const emailAddr = attendee?.bookingObject?.primaryContactDetails?.email?.toLowerCase() || "";
      const phone = attendee?.bookingObject?.primaryContactDetails?.phoneNo?.toLowerCase() || "";
      const bookingDate = new Date(attendee?.createdAt);

      const isInDateRange = (() => {
        if (fromDate && bookingDate < new Date(fromDate)) return false;
        if (toDate) {
          const endOfToDate = new Date(toDate);
          endOfToDate.setHours(23, 59, 59, 999);
          if (bookingDate > endOfToDate) return false;
        }
        return true;
      })();


      return (
        name.startsWith(search.toLowerCase()) &&
        emailAddr.startsWith(email.toLowerCase()) &&
        phone.replace(/^0+/, '').startsWith(phno.replace(/^0+/, '')) &&
        isInDateRange
      );
    });
    setAttendee(filtered);
  }, [search, email, phno, fullAttendeeList, fromDate, toDate]);
  



  const generateExportData = (data: any[]) => {
    const exportData: any[] = [];
    data.forEach((item: any) => {
      
      exportData.push({
        firstName: item?.Contact?.firstName || '',
        email: item?.Contact?.email || '',
        phoneNo: item?.Contact?.phoneNo || '',
        bookingNumber: item?.bookingNo || '',
        ticketType: item?.TicketType?.ticketType || '',
        ticketPrice: item?.TicketType?.price || '',
        totalTicketCount: item?.totalTicketCount || '',
        totalTicketAmount: item?.totalTicketAmount || '',
        grandTotal: item?.grandTotal || '',
        bookingDate: item?.createdAt || '',
        venueName: item?.Venue?.venueName || '',
      });
    });
    return exportData;
  }
  const columns = [
    {
      label: "Name", key: "firstName",
      cellContent: (row: any) => {
        return (
          <div>
            <span>{row?.Contact?.firstName}</span><br />
            <span>{row?.Contact?.email}</span><br />
            <span>{row?.Contact?.phoneNo}</span><br />
            <span>{row?.Venue?.venueName}</span><br />
          </div>
        )
      }
    },
    {
      label: "Ticket Type", key: "ticketType",
      cellContent: (row: any) => <span>{row?.TicketType?.ticketType}</span>
    },
    { label: "Total Ticket Count", key: "totalTicketCount" },
    { label: "Total Ticket Amount", key: "totalTicketAmount" },
    { label: "Grand Total", key: "grandTotal" },
    { label: "Booking Date", key: "createdAt",
      cellContent: (row: any) => <FormattedDate dateString={row?.createdAt} />
     },
  ];

  return (
    <div className="dashboard-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="d-main-title">
              <h3>
                <i className="mx-2">
                  <i className="fa-solid fa-chart-simple "></i>
                </i>
                Attendee Report
              </h3>
            </div>
          </div>
          <div className="col-md-12">
            <div className="main-card mt-5">
              <div className="dashboard-wrap-content p-2">
                <div className=" flex-wrap align-items-center">
                  <div className="dashboard-date-wrap mt-1">
                    <div className="form-group">
                      <div className="search-container position-relative d-flex flex-column flex-md-row align-items-center gap-3 p-2">
                        {/* <div className="search-group position-relative w-100 mb-2 mb-md-0">
                         
                          <CommonSelect
                            options={eventVenues}
                            value={selectedVenue}
                            onChange={(e) => onSelectedVenue(e.target.value)}
                            label="Event Venue"
                          />
                          <i className="uil uil-search position-absolute start-0 top-50 translate-middle-y ms-2"></i>
                        </div> */}
                        <div className="search-group position-relative e-w-full mb-2 mb-md-0">
                          <input
                            className="form-control h_50 ps-4"
                            type="text"
                            placeholder="Search by name"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                          />
                          <i className="uil uil-search position-absolute start-0 top-50 translate-middle-y ms-2"></i>
                        </div>
                        <div className="search-group position-relative e-w-full mb-2 mb-md-0">
                          <input
                            className="form-control h_50 ps-4"
                            type="text"
                            placeholder="Search by email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                          <i className="uil uil-search position-absolute start-0 top-50 translate-middle-y ms-2"></i>
                        </div>
                        <div className="search-group position-relative e-w-full">
                          <input
                            className="form-control h_50 ps-4"
                            type="text"
                            placeholder="Search by phone number"
                            value={phno}
                            onChange={(e) => setPhno(e.target.value)}
                          />
                        </div>
                        <div className="position-relative w-100">
                        <label>From Date:</label>
                        <FlatPickr
                          className="form-control"
                          value={fromDate}
                          onChange={([date]) => setFromDate(date)} 
                          options={{
                            dateFormat: "Y-m-d"
                          }}
                          placeholder="Select a date"
                        />
                      </div>
                        <div className="position-relative w-100">
                        <label>To Date:</label>
                        <FlatPickr
                          className="form-control"
                          value={toDate}
                          onChange={([date]) => setToDate(date)} 
                          options={{
                            dateFormat: "Y-m-d"
                          }}
                          placeholder="Select a date"
                        />
                      </div>
                      
                        <div className="export-button  position-relative w-100">
                                <ExportToExcel
                                  data={generateExportData(attendee)}
                                  fileName="Attendee_Report"
                                />
                              {/* <DropdownItem header>
                                Export Ticket Report
                              </DropdownItem>
                              <DropdownItem>
                              <ExportToExcel
                                data={exportTicketData}
                                fileName="Ticket_Report"
                              />
                              </DropdownItem> */}
                        </div>
                        {/* <div className="export-button position-relative w-100">
                          <ExportToPDF
                            data={attendee}
                            fileName="Attendee_Report"
                          />
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="rs ms-auto mt-4 mt_r4"></div>
            </div>
          </div>
        </div>
        {isLoading ? (
          <div className="d-flex justify-content-center py-4">
            <PulseLoader color="#ffffff" size={9} speedMultiplier={1} />
          </div>
        ) : (
          <div className="event-list">
            <div className="tab-content">
              <div
                className="tab-pane fade show active"
                id="orders-tab"
                role="tabpanel"
              >
                <NormalTable columns={columns} data={attendee || null} getRowId={(row: any) => row.bookingId} />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default UserAttendeeReport;
